import { SwapOutlined } from '@ant-design/icons';
import { useLazyQuery } from '@apollo/client/react';
import { Alert, Modal, Space } from 'antd';
import type React from 'react';
import { useEffect, useState } from 'react';
import { DoctorSelect } from '../../components/DoctorSelect';
import { LoadingIndicator } from '../../components/LoadingIndicator';
import { DOCTORS_FOR_CURRENT_USER_QUERY } from './AssignCurrentDoctorModal.gql';
export const AssignCurrentDoctorModal: React.FC<{
  currentDoctorId: string;
  open: boolean;
  onClose: () => void;
  onSuccess: (doctorId: string) => void;
}> = ({ currentDoctorId, open, onClose, onSuccess }) => {
  const [fetchDoctors, { loading, data }] = useLazyQuery(DOCTORS_FOR_CURRENT_USER_QUERY);

  const [selectedDoctorId, setSelectedDoctorId] = useState<string>(currentDoctorId);

  useEffect(() => {
    if (open) {
      fetchDoctors();
    }
  }, [open, fetchDoctors]);

  return (
    <Modal
      title="Zuweiser festlegen"
      okText="Zuweiser festlegen"
      okButtonProps={{ icon: <SwapOutlined />, disabled: !selectedDoctorId }}
      open={open}
      onCancel={onClose}
      onOk={() => onSuccess(selectedDoctorId)}
      confirmLoading={loading}
      destroyOnHidden
    >
      {loading ? (
        <LoadingIndicator />
      ) : (
        <Space orientation="vertical" style={{ width: '100%' }}>
          <DoctorSelect
            style={{ width: '100%' }}
            onChange={value => setSelectedDoctorId(value as string)}
            doctors={data?.doctorsForCurrentUser ?? []}
            selected={selectedDoctorId}
          />
          {!!data?.doctorsForCurrentUser?.find(it => it.id === selectedDoctorId)?.disabled && (
            <Alert
              type="warning"
              showIcon
              title="Achtung! Der ausgewählte Zuweiser ist als deaktiviert markiert. Für deaktivierte Zuweiser sollten keine neuen Anforderungen erstellt werden."
            />
          )}
        </Space>
      )}
    </Modal>
  );
};
